<template lang="pug">
div
  div(v-for='(activity, key) in activityByDate')
    strong.date-title {{ key }}
    .card-item.d-flex(v-for='activity in activity')
      div
        .date(v-if='activity.remoteCreatedDate') {{ activity.remoteCreatedDate | datePretty }}
        .date(v-else) {{ activity.createdAt | datePretty }}
      .reason
        vue-markdown(:source='activity.reason')
      .ml-auto.stats
        .exp-text(v-if='activity.experience')
          img(src='../../assets/activity/exp.svg')
          span {{ activity.experience }} EXP
        .dmg-text(v-if='activity.damage')
          img(src='../../assets/activity/damage.svg')
          span {{ activity.damage }} DMG
</template>

<style lang="scss" scoped>
  .card-item {
    text-align: left;
    padding: 1rem;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #6c6d69;
    border-top: 1px solid #e7e9e4;

    .date {
      margin-right: .5rem;
      min-width: 80px;
    }
  }

  .date-title {
    margin: 0 auto;
    margin-bottom: 1rem;
    width: 110px;
    display: block;
    text-align: center;
  }

  .reason {
    text-align: left;
    max-width: 250px;
    word-wrap: break-word;
  }

  .stats {
    min-width: 80px;
  }

  .exp-text, .dmg-text {
    min-width: 79px;
    padding: .3rem .5rem;
    border-radius: 999px;
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;

    img, span {
      vertical-align: middle;
    }

    img {
      margin-right: .2rem;
      margin-bottom: .05rem;
    }
  }

  .exp-text {
    color: #9bc75a;
    border: solid 1px #9bc75a;
  }

  .dmg-text {
    margin-top: .2rem;
    color: #a1a39e;
    border: solid 1px #a1a39e;
  }
</style>

<script>
import moment from 'moment';

import VueMarkdown from 'vue-markdown';

export default {
  props: ['activity'],
  components: {
    VueMarkdown,
  },
  filters: {
    datePretty(date) {
      return moment(date).format('hh:mm A');
    },
  },
  computed: {
    activityByDate() {
      if (!this.activity) return {};

      const { activity } = this;

      activity.sort((a, b) => {
        const firstDate = a.remoteCreatedDate || a.createdAt;
        const secondDate = b.remoteCreatedDate || b.createdAt;

        return moment(firstDate).isBefore(secondDate);
      });

      const grouped = activity.reduce((acc, curr) => {
        const createDate = curr.remoteCreatedDate || curr.createdAt;
        const date = moment(createDate).format('LL');
        if (!acc[date]) acc[date] = [];
        acc[date].push(curr);
        return acc;
      }, {});

      return grouped;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/activity/ActivityList.vue